import React, { useState } from "react";

// OTP Modal Component — extracted from LandingPage.jsx verbatim (no logic changes), so it can
// be shared by LandingPage.jsx and the common payment page without duplicating it.
const OTPModal = ({
  show,
  onClose,
  onVerify,
  mobile,
  onResend,
  resendDisabled,
  resendTimer,
  infoMessage,
}) => {
  const [otp, setOtp] = useState("");
  const [otpError, setOtpError] = useState("");
  const [verifying, setVerifying] = useState(false);

  const handleOtpChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 6);
    setOtp(value);
    setOtpError("");
  };

  const handleVerify = async () => {
    if (otp.length !== 6) {
      setOtpError("Please enter a valid 6-digit OTP");
      return;
    }

    setVerifying(true);
    try {
      await onVerify(otp);
    } catch (err) {
      setOtpError(err.message || "Invalid OTP. Please try again.");
    } finally {
      setVerifying(false);
    }
  };

  const handleResend = () => {
    setOtp("");
    setOtpError("");
    onResend();
  };

  if (!show) return null;

  return (
    <div
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        background: "rgba(0,0,0,0.5)",
        zIndex: 10001,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "20px",
      }}
    >
      <div
        style={{
          background: "white",
          borderRadius: "12px",
          padding: "24px",
          maxWidth: "400px",
          width: "100%",
          boxShadow: "0 10px 25px rgba(0,0,0,0.2)",
          textAlign: "center",
        }}
      >
        <div
          style={{
            fontSize: "18px",
            fontWeight: 600,
            color: "#f57c00",
            marginBottom: "12px",
          }}
        >
          🔐 OTP Verification
        </div>
        <div
          style={{
            fontSize: "14px",
            color: "#666",
            marginBottom: "20px",
            lineHeight: 1.5,
          }}
        >
          We've sent a 6-digit OTP to
          <br />
          <strong>{mobile}</strong>
        </div>
        {infoMessage && (
          <div
            style={{
              color: "#f57c00",
              fontWeight: 500,
              marginBottom: 8,
              textAlign: "center",
            }}
          >
            {infoMessage}
          </div>
        )}
        <input
          type="text"
          value={otp}
          onChange={handleOtpChange}
          placeholder="Enter 6-digit OTP"
          maxLength={6}
          style={{
            width: "100%",
            padding: "12px",
            fontSize: "16px",
            border: otpError ? "2px solid #ff3d00" : "2px solid #ddd",
            borderRadius: "6px",
            textAlign: "center",
            letterSpacing: "2px",
            marginBottom: "12px",
            outline: "none",
          }}
          onKeyDown={(e) => e.key === "Enter" && handleVerify()}
        />

        {otpError && (
          <div
            style={{
              color: "#ff3d00",
              fontSize: "12px",
              marginBottom: "16px",
            }}
          >
            {otpError}
          </div>
        )}

        <div style={{ marginBottom: "20px" }}>
          <button
            onClick={handleVerify}
            disabled={verifying || otp.length !== 6}
            style={{
              backgroundColor:
                verifying || otp.length !== 6 ? "#ccc" : "#4caf50",
              color: "white",
              border: "none",
              borderRadius: "6px",
              padding: "12px 24px",
              fontSize: "14px",
              fontWeight: 500,
              cursor: verifying || otp.length !== 6 ? "not-allowed" : "pointer",
              width: "100%",
              marginBottom: "10px",
            }}
          >
            {verifying ? "Verifying..." : "Verify OTP"}
          </button>

          <button
            onClick={handleResend}
            disabled={resendDisabled}
            style={{
              backgroundColor: "transparent",
              color: resendDisabled ? "#ccc" : "#f57c00",
              border: "none",
              fontSize: "12px",
              cursor: resendDisabled ? "not-allowed" : "pointer",
              textDecoration: "underline",
            }}
          >
            {resendDisabled ? `Resend OTP in ${resendTimer}s` : "Resend OTP"}
          </button>
        </div>

        <button
          onClick={onClose}
          style={{
            backgroundColor: "#666",
            color: "white",
            border: "none",
            borderRadius: "6px",
            padding: "8px 16px",
            fontSize: "12px",
            cursor: "pointer",
          }}
        >
          Cancel
        </button>
      </div>
    </div>
  );
};

export default OTPModal;
